/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Add_TitleInputs */



/**
* | output |
* | --- |
* | "Add Project Metadata" |
*
* @param {Options_Metadata_Add_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_add_title = /** @type {((inputs?: Options_Metadata_Add_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Add_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter des métadonnées au projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektmetadaten hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi metadati del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить метаданные проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar metadatos del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加项目元数据")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトメタデータを追加する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट मेटाडेटा जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar metadados do projeto")
	return /** @type {LocalizedString} */ ("Add Project Metadata")
});